var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isV3)?_c('top-v3'):_c('top')}
var staticRenderFns = []

export { render, staticRenderFns }